module.exports = __webpack_public_path__ + "img/close-button.6b9ac7a9.svg";